import React from 'react';
import styled, {css} from 'styled-components';
import {Padding, p} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import moment from 'moment';
import {Stack, Box, Columns, Column} from '@nib/layout';
import Link from '@nib-components/link';
import {PrimaryButton} from '@nib-components/button';
import Heading from '@nib-components/heading';
import Copy, {Italic} from '@nib-components/copy';
import colors from '@nib-components/colors';
import {colorBrandBase} from '@nib-components/theme';

import contentfulService from '../../services/contentfulService';

const CardWrapper = styled.div`
  display: grid;
  grid-template-rows: 150px 1fr;
  ${breakpoint('md')`
    grid-template-rows: 180px 1fr;
  `};
  background: ${colors.white};
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px hsla(0, 0%, 0%, 0.13);
  padding: 1px;
`;

const CardPicture = styled.div`
  border-bottom: 1px solid ${colors.sneezy};
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  ${({img}) =>
    img &&
    css`
      background-image: url(${img});
      background-repeat: no-repeat;
      background-size: cover;
    `}
`;

const CardContentWrapper = styled.div`
  ${p(4)};
  overflow: hidden;
`;

const CardTitle = styled.div`
  line-height: 1.5em;
  height: 3em;
  overflow: hidden;
`;

const CardDescription = styled.div`
  line-height: 1.5em;
  height: 3em;
  overflow: hidden;
`;

const BlogPosts = () => {
  const [blogs, setBlogs] = React.useState(null);
  const [assets, setAssets] = React.useState(null);

  React.useEffect(() => {
    const fetchBlogs = async () => {
      const response = await contentfulService.fetchBlogArticles();
      setBlogs(response.data.items);
      setAssets(response.data.includes.Asset);
    };
    if (!blogs) {
      fetchBlogs();
    }
  });

  return (
    <Box>
      <Padding bottom={{xs: 4, md: 4, lg: 6}}>
        <Heading color="trueGreen" size={{sm: 4, md: 3, lg: 2}} component="h2">
          Health and Wellbeing
        </Heading>
      </Padding>
      <Columns space={{xs: 2, lg: 6}} collapseBelow="md" align={{xs: 'center', lg: 'left'}} verticalAlign="top">
        {blogs &&
          blogs.map((article, index) => (
            <Column width="1/3" key={index}>
              <CardWrapper>
                <CardPicture img={assets && assets.find(a => a.sys.id === article.fields.thumbnail.sys.id).fields.file.url} />
                <CardContentWrapper>
                  <Stack space={4}>
                    <CardTitle>
                      <Copy color={colorBrandBase}>{article.fields.title}</Copy>
                    </CardTitle>
                    <Stack space={1}>
                      <Italic small>{moment(article.fields.startDate).format('Do MMMM YYYY')}</Italic>
                      <CardDescription>
                        <Copy>{article.fields.summary}</Copy>
                      </CardDescription>
                    </Stack>

                    <Link href={`https://www.nib.co.nz/free-resources/article/${article.fields.urlSlug}`} target="_blank">
                      Keep reading
                    </Link>
                  </Stack>
                </CardContentWrapper>
              </CardWrapper>
            </Column>
          ))}
      </Columns>
      <Box display="flex" justifyContent="center">
        <Padding all={6}>
          <PrimaryButton href="https://www.nib.co.nz/free-resources" target="_blank">
            See all articles
          </PrimaryButton>
        </Padding>
      </Box>
    </Box>
  );
};

BlogPosts.displayName = 'BlogPosts';

export default BlogPosts;
